import { motion } from "framer-motion";
import { Quote, BadgeCheck } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const LOGO_SLOTS = ["Partner logo", "Partner logo", "Partner logo", "Partner logo"];

export default function Testimonials() {
    return (
        <section id="partners" data-testid="testimonials-section" className="relative py-24 sm:py-32 overflow-hidden">
            <div className="absolute -top-32 -right-32 h-[420px] w-[420px] rounded-full bg-[#A6CE39]/15 blur-[110px] pointer-events-none" aria-hidden />

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl mx-auto text-center">
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.7, ease: EASE }}
                        className="font-mono-brand text-xs tracking-[0.25em] uppercase text-[#3FAE4A] mb-5"
                        data-testid="testimonials-eyebrow"
                    >
                        Word on the floor
                    </motion.p>
                    <motion.h2
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
                        className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.1] tracking-tight text-[#0E1E12]"
                        data-testid="testimonials-heading"
                    >
                        What Northern Virginia offices are saying
                    </motion.h2>
                </div>

                <motion.figure
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
                    className="relative max-w-4xl mx-auto mt-14 rounded-3xl border border-[#1B4D1B]/10 bg-white px-8 py-12 sm:px-14 shadow-[0_30px_80px_-30px_rgba(14,30,18,0.25)]"
                    data-testid="testimonial-quote-card"
                >
                    <span className="absolute -top-6 left-10 h-12 w-12 rounded-2xl bg-[#F58220] flex items-center justify-center shadow-[0_12px_30px_-8px_rgba(245,130,32,0.5)]">
                        <Quote className="h-5 w-5 text-white" />
                    </span>
                    <blockquote className="font-display text-2xl sm:text-3xl font-semibold leading-snug tracking-tight text-[#0E1E12]">
                        "The machine basically runs itself. Snack runs stopped, the breakroom finally
                        feels like a real perk — and it didn't cost us a dime."
                    </blockquote>
                    <figcaption className="mt-8 flex items-center gap-4">
                        <span className="h-11 w-11 rounded-full bg-[#A6CE39]/25 flex items-center justify-center font-display font-bold text-[#1B4D1B]">
                            OM
                        </span>
                        <span>
                            <span className="block font-semibold text-[#0E1E12] text-sm">Office Manager</span>
                            <span className="block text-xs text-[#768578]">Northern Virginia workplace</span>
                        </span>
                    </figcaption>
                    <p
                        className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#F1EFE6] px-4 py-1.5 font-mono-brand text-[10px] tracking-[0.2em] uppercase text-[#4A584C]"
                        data-testid="testimonial-placeholder-note"
                    >
                        <BadgeCheck className="h-3.5 w-3.5 text-[#3FAE4A]" />
                        Sample quote — first partner story coming soon
                    </p>
                </motion.figure>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.8, delay: 0.25, ease: EASE }}
                    className="mt-14"
                    data-testid="partner-logos-row"
                >
                    <p className="text-center font-mono-brand text-[11px] tracking-[0.25em] uppercase text-[#768578] mb-6">
                        Partner offices — logos on the way
                    </p>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
                        {LOGO_SLOTS.map((label, i) => (
                            <div
                                key={i}
                                data-testid={`partner-logo-slot-${i + 1}`}
                                className="h-20 rounded-2xl border-2 border-dashed border-[#1B4D1B]/15 flex items-center justify-center transition-colors duration-300 hover:border-[#3FAE4A]/40"
                            >
                                <span className="font-mono-brand text-[10px] tracking-[0.25em] uppercase text-[#768578]/70">
                                    {label} {String(i + 1).padStart(2, "0")}
                                </span>
                            </div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
